// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_im-a";
export var fulfillmentFormRail = "_im-9";
export var headerTitleRow = "_im-c";
export var orderDetailsWrapper = "_im-7";
export var orderLinkTrigger = "_im-2";
export var paymentInformationGrid = "_im-h";
export var paymentSummaryColumn = "_im-i";
export var shipmentContainer = "_im-b";
export var shipmentDetailsMainPane = "_im-8";
export var shipmentNavigationCard = "_im-5";
export var shipmentNavigationRail = "_im-3";
export var shipmentNavigationRailHeader = "_im-4";
export var shipmentSummaryFact = "_im-e";
export var shipmentSummaryGrid = "_im-d";
export var shipmentSummaryMetadataRow = "_im-f";
export var shipmentSummaryTags = "_im-g";
export var shipmentWorkspace = "_im-0";
export var shipmentWorkspaceContent = "_im-6";
export var shipmentWorkspaceHeader = "_im-1";